module.exports = __webpack_public_path__ + "static/media/ill_urinvagsbesvar.ab6d50b9.svg";